import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const CustomSubmit = ({ value, className, disabled }) => {
    const classes = classNames("custom-submit", className, { disabled: disabled });

    return (
        <input type="submit" value={value} className={classes} disabled={disabled} />
    );
};

CustomSubmit.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool
};

CustomSubmit.defaultProps = {
    disabled: false
};

export default CustomSubmit;
